export default __webpack_public_path__ + "static/media/CZE.01f884ca.svg";